const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const AT = require("../vault/ActionTypes");

const styles = require("./styles/PrivacyBanner.css");

const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "PrivacyBanner",

		propTypes: {
			pageType: PT.string,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				isPrivacyChecked: false,
			};
		},

		handleCheckboxChange: function(event) {
			this.setState({isPrivacyChecked: event.target.checked});
		},

		acceptPrivacy: function() {
			if (this.state.isPrivacyChecked) {
				this.props.dispatch({type: AT.ACCEPT_PRIVACY_REQUEST});
			}
		},

		render: function() {
			const {pageType} = this.props;
			let mainStyle = styles.account;
			if (pageType === "report") {
				mainStyle = styles.report;
			}

			return (
				<div className={mainStyle}>
					<div className={styles.text}>
						<p>
							Agree to Terms & Conditions in order to manage your student's
							access to Beast Academy Online.
						</p>
						<p>
							<input
								type="checkbox"
								name="privacyAgree"
								id="privacyAgree"
								onChange={this.handleCheckboxChange}
							/>{" "}
							<label htmlFor="privacyAgree" className={styles.label}>
								I agree to the Beast Academy{" "}
								<a className={styles.link} href="/terms" target="_blank">
									Terms & Conditions
								</a>{" "}
								and{" "}
								<a className={styles.link} href="/privacy" target="_blank">
									Privacy Policy
								</a>
							</label>
						</p>
					</div>
					<div className={styles.save}>
						<button
							className={`${styles.button} ${
								!this.state.isPrivacyChecked ? styles.disabled : ""
							}`}
							disabled={!this.state.isPrivacyChecked}
							onClick={this.acceptPrivacy}
						>
							{"Save"}
						</button>
					</div>
				</div>
			);
		},
	})
);
